

















/* eslint-disable */

import Vue from "vue";
import VueRouter from 'vue-router'
//import Contact from "./components/Master/ContactUs";
import fb from "../config";
import Nav from "./navbar.vue";
import Slider from "./homepageslider.vue";
import About from "./about.vue";
import Ourproducts from "./ourproducts.vue";
import Bestsellers from "./bestsellers.vue";
import Contact from "./contact.vue";
import Contactus from "./contactustitle.vue";
import Footer from "./footer.vue";

export default Vue.extend({
  name: "app",
  components: {
    Contact,Contactus,Footer,Bestsellers,Ourproducts,About,Slider,Nav
  },
  methods: {

  }
});
